export function arrayContains(array, value) {
    for (let i = 0, c = array.length; i < c; i++) {
        if (array[i] == value) {
            return true;
        }
    }

    return false;
}

export function removeFromArray(array, member) {
    if (!array) {
        return;
    }

    const index = array.indexOf(member);

    if (index !== -1) {
        array.splice(index, 1);
    }
}
